<template>
  <div>
       <vue-headful
            title="404 Page Not Found - Girish Jewellers"
            description="Girish Jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>

          <section id="main">
            <div class="container">
              <div class="row">
                <div class="content span12">
              <div class="row">
                <div class="span6">
                <div class="box-404 bg">
                  <h1>404</h1>
                  <h2>The page cannot be found.</h2>
                </div>
                </div>
                <div class="span6">
                <h3>Page not found!</h3>
                <p>The page you requested was not found, and we have a fine guess why.</p>
                <ul>
                  <li>If you typed the URL directly, please make sure the spelling is correct.</li>
                  <li>If you clicked on a link to get here, the link is outdated.</li>
                </ul>
                <b>What can you do?</b>
                <p>Have no fear, help is near! There are many ways you can get back on track with Store.</p>
                <ul>
                  <li><a href="javascript:void(0);" onclick="window.history.back();">Go back</a> to the previous page.</li>
                  <li>Use the search bar at the top of the page to search for your products. Follow these links to get you back on track!</li>
                  <li><router-link to="/">Home</router-link> | <router-link to="/account">My Account</router-link></li>
                </ul>
                </div>
              </div>
                </div>
              </div>
            </div><!-- .container -->
          </section><!-- #main -->

        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile()"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import {mapGetters, mapActions} from "vuex";
import vueHeadful from 'vue-headful';


export default {
  name: 'PageNotFound',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    Footer,
    FooterWeb
    },created(){
        this.getSession;
    },
    computed:mapGetters(["Session"]),
    watch:{
        Session() {}
    },
    mounted:function(){
      this.loadOnMount();
    },
    data:function(){
        return {results: {} };
    },
    methods:{
      ...mapActions(["getSession"]),
      isMobile:function(){
   return Common.isMobile();
},
loadOnMount: function() {
      
      Common.stopAjaxLoader();
      $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
        });
    }

  }
    
}
</script>